"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonMessages_en_us = void 0;
function commonMessages_en_us() {
    return {
        "messages.errors.notinsamecompany": "You can only send messages to people in your company!",
        "messages.errors.messagenotfound": "Message could not be found.",
        "messages.errors.recipienttypenotfound": "The following recipient type could not be found: ",
        "messages.errors.recipientnotfound": "The message recipient could not be found.",
        "messages.errors.wrongreseller": "Wrong reseller for this tenant.",
        "messages.errors.isdifferentproject": "Message can not be sent to different projects.",
        "messages.errors.isnotprojectmember": "Message recipient is not a project member.",
        "messages.errors.sendingnotallowed": "Only users and projects can send messages",
        "messages.system.exportdone": "Your data export is done!",
        "messages.system.downloadexport": "Download exported data",
        "messages.system.acceptedinvitation": "has accepted your invitation."
    };
}
exports.commonMessages_en_us = commonMessages_en_us;
